import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "comprehensive exercise-container"
};
var _hoisted_2 = {
  class: "exercise-container-title flex"
};
var _hoisted_3 = {
  class: "exercise-container-title-left"
};
var _hoisted_4 = {
  class: "exercise-time"
};
var _hoisted_5 = {
  key: 0,
  class: "nested"
};
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
  class: "exercise-container-options"
};
var _hoisted_8 = {
  class: "subjects"
};
var _hoisted_9 = ["data-type"];
var _hoisted_10 = {
  class: "exercise-container-tags"
};
import { EXERCISE_TYPE_ENUM, EXERCISE_TYPE_NAME } from '@/const/enum';
import components from './component';
import publicProps from './props';
export default {
  __name: 'Comprehensive',
  props: publicProps,
  setup: function setup(__props) {
    var props = __props;

    /**
     * 习题内容的渲染函数
     * @param props 传值
     * @param slots 插槽
     * @returns {VNode}
     * @constructor
     */
    // const ExerciseCompRenderFunction = (props) => {
    //   console.log(props);
    //   return h(components[props.type], {
    //     type: props.type,
    //     data: props.data,
    //     index: props.index + 1,
    //     answer: props.answer,
    //     options: props.options,
    //   });
    // };

    return function (_ctx, _cache) {
      var _props$data;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!props.isNested ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          flex: !props.isApp
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'exercise-type': true,
          'margin-b': props.isApp
        })
      }, _toDisplayString(_unref(EXERCISE_TYPE_NAME)[props.type]), 3), _createElementVNode("div", {
        class: _normalizeClass({
          flex: props.isApp
        })
      }, [_createElementVNode("span", _hoisted_4, _toDisplayString(props.data._createTime), 1), _createElementVNode("span", null, _toDisplayString(props.data.fromWhere), 1)], 2)], 2)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "handle")]), _createElementVNode("div", {
        class: _normalizeClass({
          'exercise-container-content': true,
          isDetail: props.detail
        })
      }, [props.isNested ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString("".concat(props.index, ".")) + "【" + _toDisplayString(_unref(EXERCISE_TYPE_NAME)[props.type]) + "】", 1)) : _createCommentVNode("", true), _createElementVNode("p", {
        innerHTML: props.data.exercise.content
      }, null, 8, _hoisted_6)], 2), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.exercise.childs, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          class: "subjects-item",
          "data-type": _unref(EXERCISE_TYPE_ENUM)[item.type]
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(components)[_unref(EXERCISE_TYPE_ENUM)[item.type]]), {
          index: index + 1,
          data: {
            exercise: item
          },
          type: _unref(EXERCISE_TYPE_ENUM)[item.type],
          "show-operation": false,
          "show-type": false,
          "is-nested": ""
        }, null, 8, ["index", "data", "type"]))], 8, _hoisted_9);
      }), 128))])]), _createElementVNode("div", _hoisted_10, [_renderSlot(_ctx.$slots, "tags")]), _renderSlot(_ctx.$slots, "info")]);
    };
  }
};